/**
 * Class & ID Selectors
 * These selectors can be used by the developer to change the any of the styles
 * using CSS.
 */

// Modal
export const WEB3_CONNECT_MODAL_ID = 'rlogin-connect-modal'
export const MODAL_LIGHTBOX_CLASSNAME = 'rlogin-modal-lightbox'
export const MODAL_CONTAINER_CLASSNAME = 'rlogin-modal-container'
export const MODAL_HITBOX_CLASSNAME = 'rlogin-modal-hitbox'
export const MODAL_CARD_CLASSNAME = 'rlogin-modal-card'
export const MODAL_CLOSE_BUTTON_CLASSNAME = 'rlogin-modal-close-button'
export const MODAL_HEADER_CLASSNAME = 'rlogin-modal-header'
export const MODAL_BODY_CLASSNAME = 'rlogin-modal-body'

// Choosing a provider, step 1
export const PROVIDERS_WRAPPER_CLASSNAME = 'rlogin-providers-wrapper'
export const PROVIDER_CONTAINER_CLASSNAME = 'rlogin-provider-container'
export const PROVIDER_CONTAINER_DISABLED_CLASSNAME = 'rlogin-provider-disabled-container'
export const PROVIDER_ICON_CLASSNAME = 'rlogin-provider-icon'
export const PROVIDERS_FOOTER_TEXT_CLASSNAME = 'rlogin-footer-text'
export const PROVIDERS_DEVELOPER_CLASSNAME = 'rlogin-developer-providers'
export const PROVIDERS_INJECTED = 'rlogin-providers-injected'
export const PROVIDERS_MOBILE = 'rlogin-providers-mobile'
export const PROVIDERS_CUSTODIAL = 'rlogin-providers-custodial'
export const PROVIDERS_HARDWARE = 'rlogin-providers-hardware'

// Typography
export const HEADER2_CLASS = 'rlogin-header2'
export const HEADER3_CLASS = 'rlogin-header3'
export const PARAGRAPH_CLASS = 'rlogin-paragraph'
export const BIG_PARAGRAPH_CLASS = 'rlogin-big-paragraph'
export const ANCHOR_CLASSNAME = 'rlogin-anchor'
export const BUTTON_CLASSNAME = 'rlogin-button'
export const LIST_TITLE = 'rlogin-list-title'
export const LIST_DESCRIPTION = 'rlogin-list-description'
export const LIST_NETWORK = 'rlogin-list-network'
export const LIST_CLICKABLE = 'rlogin-list-clickable'
export const SMALL_SPAN = 'rlogin-small-span'
export const CHECKBOX_CLASSNAME = 'rlogin-checkbox'

// Error Handling
export const ERROR_MESSAGE_WRAPPER = 'rlogin-error-message'
export const ERROR_ICON_WRAPPER = 'rlogin-error-icon'
